var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpa = function SvgSpa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.938 6.271a2.917 2.917 0 1 1 4.124 4.125 2.917 2.917 0 0 1-4.124-4.125ZM15 7.917a.417.417 0 1 0 0 .833.417.417 0 0 0 0-.833ZM4.604 26.271a2.917 2.917 0 1 1 4.125 4.125 2.917 2.917 0 0 1-4.125-4.125Zm2.063 1.646a.417.417 0 1 0 0 .834.417.417 0 0 0 0-.834Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.333 27.083c-.69 0-1.25.56-1.25 1.25v4.227l-5.975 2.988a1.25 1.25 0 0 0 1.118 2.236l6.666-3.333a1.25 1.25 0 0 0 .691-1.118v-3.75h18.75a1.25 1.25 0 1 0 0-2.5h-20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.083 33.333c0-.69.56-1.25 1.25-1.25h15a1.25 1.25 0 0 1 0 2.5h-15c-.69 0-1.25-.56-1.25-1.25ZM20.395 12.147a1.25 1.25 0 0 0-1.608.883l-1.55 6.198-4.597 3.065a1.25 1.25 0 0 0 1.387 2.08l5-3.333a1.25 1.25 0 0 0 .519-.737l1.306-5.222c1.246.741 1.933 1.81 2.337 3.022.55 1.651.561 3.53.561 5.23a1.25 1.25 0 1 0 2.5 0v-.071c0-1.628 0-3.88-.69-5.95-.727-2.182-2.23-4.187-5.165-5.165Z"
  })));
};
export default SvgSpa;